import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import WarehouseTypeIndexController from 'cio/pods/integrations/warehouse/type/index/controller';
import { redirectIfNoAccessToWarehouseSync } from 'cio/utils/route-access';

export default class IntegrationsWarehouseIndexRoute extends Route {
  resetController(controller: WarehouseTypeIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoAccessToWarehouseSync(this, transition);
  }
}
